import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationDE from "./locales/de/translation.json";

const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
};

i18n
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next) // Passes i18n to React
  .init({
    resources,
    fallbackLng: "de",
    detection: {
      // Order and methods for detecting language
      order: ["localStorage", "navigator", "htmlTag", "cookie", "querystring"],
      caches: ["localStorage"], // persist selected language
    },
    interpolation: {
      escapeValue: false, // react already protects from XSS
    },
  });

// Log the detected language after initialization

export default i18n;
